export const SAMSUNG_COMPANY_ID = '1'

export const SECOND_HALF_ID = '1'
export const FIRST_HALF_ID_GSAT = '2'

export const GSAT_2025_2_EXAM_TERM_ID = '4' // 2025 하반기
